"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseRpcResponse = void 0;
class BaseRpcResponse {
    constructor(id, result, error) {
        this.jsonrpc = "2.0";
        this.id = id;
        this.result = result;
        this.error = error;
    }
}
exports.BaseRpcResponse = BaseRpcResponse;
//# sourceMappingURL=rpc-response.type.js.map